import FastInput from './FastInput'
export default FastInput
